/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdatePalReauthEmrDocumentSelection200ResponseData } from './UpdatePalReauthEmrDocumentSelection200ResponseData';
import {
    UpdatePalReauthEmrDocumentSelection200ResponseDataFromJSON,
    UpdatePalReauthEmrDocumentSelection200ResponseDataFromJSONTyped,
    UpdatePalReauthEmrDocumentSelection200ResponseDataToJSON,
} from './UpdatePalReauthEmrDocumentSelection200ResponseData';

/**
 * 
 * @export
 * @interface UpdatePalReauthEmrDocumentSelection200Response
 */
export interface UpdatePalReauthEmrDocumentSelection200Response {
    /**
     * 
     * @type {UpdatePalReauthEmrDocumentSelection200ResponseData}
     * @memberof UpdatePalReauthEmrDocumentSelection200Response
     */
    data?: UpdatePalReauthEmrDocumentSelection200ResponseData;
}

/**
 * Check if a given object implements the UpdatePalReauthEmrDocumentSelection200Response interface.
 */
export function instanceOfUpdatePalReauthEmrDocumentSelection200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdatePalReauthEmrDocumentSelection200ResponseFromJSON(json: any): UpdatePalReauthEmrDocumentSelection200Response {
    return UpdatePalReauthEmrDocumentSelection200ResponseFromJSONTyped(json, false);
}

export function UpdatePalReauthEmrDocumentSelection200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthEmrDocumentSelection200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : UpdatePalReauthEmrDocumentSelection200ResponseDataFromJSON(json['data']),
    };
}

export function UpdatePalReauthEmrDocumentSelection200ResponseToJSON(value?: UpdatePalReauthEmrDocumentSelection200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': UpdatePalReauthEmrDocumentSelection200ResponseDataToJSON(value.data),
    };
}

